import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AdminSpecificEmployeeView, GetadminDepartmentList, AdminDepartmentUpdate } from "../../Repository/Api";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { errorMsg, successMsg } from "../Toastify";
import LeaveInfo from "../Common/LeaveInfo";
import LeaveHistory from "../Common/LeaveHistory";
const AdminEmployeeSpecificView = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();
  const navigate = useNavigate();

  const [specificEmployee, setSpecificEmployee] = useState({});

  const [departmentt, setDepartment] = useState([]);

  const tabs = ["Basic Info", "Leave Info", "Leave History"]
  const [active, setActive] = useState(0)
  const profiletype = specificEmployee?.officer_type
  useEffect(() => {
    getSpecificEmployee();
    getDepartment()
  }, []);

  const getDepartment = async () => {
    const response = await GetadminDepartmentList(token);
    if (response && response.statusCode === 200) {
      setDepartment(response?.data?.department);
    } else {
      errorMsg(response.message);
    }
  };
  const getSpecificEmployee = async () => {
    const response = await AdminSpecificEmployeeView(id, token);
    if (response && response.statusCode === 200) {
      setSpecificEmployee(response.data);
    } else {
      errorMsg(response.message);
    }
  };
  const setNormalData = (e, key) => {
    setSpecificEmployee({ ...specificEmployee, [key]: e });
  };
  const handleSubmit = async (e) => {
    e.preventDefault()
    const payload = {
      employee_id: specificEmployee?.id,
      department_id: specificEmployee?.department_id
    }

    const response = await AdminDepartmentUpdate(payload, token)
    if (response && response?.statusCode === 200) {
      successMsg(response?.message)
      navigate(-1)
    }
  }
  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section className="my-3">
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Employee List
                </h6>
                <div className="row">
                  <div className="col-lg-4 mx-auto ms-auto">
                    <ul className="searchtopflex">
                      {tabs.map((link, index) => {
                        return (
                          <li
                            onClick={() => setActive(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                {active === 0 &&
                  <div className="row">
                    <div className="col-lg-3">
                      <label className="labeltext">Name of the Applicant</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={specificEmployee?.first_name}
                        disabled
                      />
                    </div>
                    <div className="col-lg-3">
                      <label className="labeltext">Last Name</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={specificEmployee?.last_name}
                        disabled
                      />
                    </div>
                    {specificEmployee?.user_type_value === "employee" ? (
                      <div className="col-lg-3">
                        <label className="labeltext">Designation</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={specificEmployee?.designation}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="col-lg-3">
                      <label className="labeltext">Department</label>
                      <select
                        className="fieldinput"
                        value={specificEmployee?.department_id}
                        onChange={(e) => {
                          setNormalData(e.target.value, "department_id");
                        }}
                      >
                        {departmentt?.map((e, index) => (
                          <option key={index} value={e.id}>
                            {e.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {specificEmployee?.user_type_value === "employee" ? (
                      <div className="col-lg-3">
                        <label className="labeltext"> Employee ID </label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={specificEmployee?.employee_id}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="col-lg-3">
                      <label className="labeltext">Email ID</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={specificEmployee?.email_id}
                        disabled
                      />
                    </div>
                    <div className="col-lg-3">
                      <label className="labeltext">Phone Number</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={specificEmployee?.phone_number}
                        disabled
                      />
                    </div>
                    {specificEmployee?.user_type_value === "employee" ? (
                      <div className="col-lg-3">
                        <label className="labeltext"> Gender</label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={specificEmployee?.gender}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="col-lg-3">
                      <label className="labeltext">Date Of Birth</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={moment(specificEmployee?.dob).format("DD-MM-yyyy")}
                        disabled
                      />
                    </div>
                    <div className="col-lg-3">
                      <label className="labeltext">Date Of Join</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={moment(specificEmployee?.doj).format("DD-MM-yyyy")}
                        disabled
                      />
                    </div>
                    {specificEmployee?.user_type_value === "employee" ? (
                      <div className="col-lg-3">
                        <label className="labeltext">Staff Type</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={specificEmployee?.officer_type}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {specificEmployee?.user_type_value === "employee" ? (
                      <div className="col-lg-3">
                        <label className="labeltext">Marital Status</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={specificEmployee?.marital_status}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="mt-5 text-center">
                      <button
                        className="requestbtn"
                        onClick={handleSubmit}
                      >Update</button>
                    </div>
                  </div>
                }
                {active === 1 &&
                  <LeaveInfo profile={profiletype} />
                }
                {active === 2 &&
                  <LeaveHistory />
                }
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminEmployeeSpecificView;
